import { ConditionRows } from '../controls/ConditionRows.js';
import type { ForkStepEditorProps } from './types.js';

export const BranchStepEditor = ({ step, path, ctx, vars, Arm }: ForkStepEditorProps<'branch'>) => {
  return (
    <>
      <p className="text-xs text-ink-subtle">
        Cases are checked top to bottom — the first match wins; Otherwise catches everything else.
      </p>
      {step.cases.map((kase, ci) => (
        <Arm
          key={ci}
          label={kase.label}
          emptyText="Nothing happens for this case — that's allowed; it just gets recorded."
          steps={kase.steps}
          containerPath={[...path, 'cases', ci, 'steps']}
          ctx={ctx}
          when={
            <ConditionRows
              conditions={kase.when.conditions}
              vars={vars}
              match={kase.when.match}
              onMatchChange={(m) =>
                ctx.onUpdateCase(path, ci, { when: { ...kase.when, match: m } })
              }
              onChange={(c) =>
                ctx.onUpdateCase(path, ci, { when: { ...kase.when, conditions: c } })
              }
            />
          }
          onRemoveArm={step.cases.length > 1 ? () => ctx.onRemoveCase(path, ci) : undefined}
          onRenameArm={(v) => ctx.onUpdateCase(path, ci, { label: v })}
        />
      ))}
      <button
        type="button"
        className="mt-1 justify-self-start text-xs text-ink-muted hover:text-ink"
        onClick={() => ctx.onAddCase(path)}
      >
        + Add case
      </button>
      <Arm
        label="Otherwise"
        emptyText="Nothing happens for anything that doesn't match above."
        steps={step.otherwise}
        containerPath={[...path, 'otherwise']}
        ctx={ctx}
      />
    </>
  );
};
